import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsStaffPayments(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_STAFF_PAYMENTS, ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENTS, options)
}
function _getReportsStaffPayment(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_STAFF_PAYMENTS, ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT, options)
  
}
function _getReportsStaffPaymentPreview(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_STAFF_PAYMENTS, ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT_PREVIEW, options)
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENTS]: _getReportsStaffPayments,
  [ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT]: _getReportsStaffPayment,
  [ModulesConfigMap[ModulesMap.REPORTS_STAFF_PAYMENTS].GET_REPORTS_STAFF_PAYMENT_PREVIEW]: _getReportsStaffPaymentPreview,
}